import { AuthContext } from 'AuthContext'
import useEledoUserMemberships from 'graphql/hooks/useUserMemberships'
import React, { useContext } from 'react'
import classnames from 'classnames';
import { EledoAccountMember } from 'graphql/EledoAccountMemberQueries';
import { EledoMemberRoles } from './EledoAccountMembersList';
import { Link } from 'react-router-dom';

const EledoUserMembershipsList = () => {
  const auth = useContext(AuthContext)
  const { membershipsLoading, error, memberships } = useEledoUserMemberships({limit: 10, page: 1})

  return (
    <>
    <div className={classnames("w-layout-grid", "header-grid")} style={{marginTop: 0}}>
      <div className="_wf-table-cell">
        <div>Name</div>
      </div>
      <div className="_wf-table-cell">
        <div>Role</div>
      </div>
      <div className="_wf-table-cell">
        <div>Actions</div>
      </div>
    </div>
    { memberships?.map((member, index) => (
      <div className={classnames("w-layout-grid", "data-grid")} key={member.account.id}>
        <div className="_wf-table-cell">
          { member.account.name }
        </div>
        <div className="_wf-table-cell">
          <div>
            <EledoMemberRoles member={member} />
          </div>
        </div>
        <div className="_wf-table-cell">
          <div>
            <EledoMemberActions member={member} currentAccountId={auth.account?.id}/>
          </div>
        </div>
      </div>))
    }
    </>
  )
}

const EledoMemberActions = ({member, currentAccountId}: { member: EledoAccountMember, currentAccountId?: string }) => {
  const isAdmin = member.roles.includes("AccountAdmin")
  const canSettings = currentAccountId === member.account.id && isAdmin
  const canSwitch = currentAccountId !== member.account.id

  return (
    <div>
      { canSettings &&
        <Link className="w-button button outline" to={'/account'}><i className="icon-cog" /> Account Settings</Link>
      }
      {/* { canSwitch &&
        <EledoButton onClick={() => {

        }}>
          <i className="icon-spinner11" /> Switch To
        </EledoButton>
      } */}
    </div>
  )
}

export default EledoUserMembershipsList